<div class="container mt-3">
  <div class="row justify-content-center" *ngIf="!showSpinner && translationCompleted">
    <div class="col-md-8 col-lg-10">
      <mdb-card class="card-cascade narrower">
        <div class="view card-header indigo white-text text-center">
          {{ Localization.ConfirmLoginForChappsBuilding | translate}}
        </div>
        <mdb-card-body>
          <div class="row">
            <div class="col-md-3 col-lg-3 label-column-text">
              <h5 class="pb-3 font-weight-bold">
                {{ Localization.Business | translate}}
              </h5>
            </div>
            <div class="col-md-1 col-lg-1">
            </div>
            <div class="col-md-7 col-lg-7">
              <h5 class="pb-3">
                {{account.businessName}}
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-lg-3 label-column-text">
              <h5 class="pb-3 font-weight-bold">
                {{ Localization.Contact | translate}}
              </h5>
            </div>
            <div class="col-md-1 col-lg-1">
            </div>
            <div class="col-md-7 col-lg-7">
              <h5 class="pb-3">
                {{account.fullName}}
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-lg-3 label-column-text">
              <h5 class="pb-3 font-weight-bold">
                {{ Localization.Username | translate}}
              </h5>
            </div>
            <div class="col-md-1 col-lg-1">
            </div>
            <div class="col-md-7 col-lg-7">
              <h5 class="pb-3">
                {{account.username}}
              </h5>
            </div>
          </div>
          <div *ngIf="account.newPasswordRequired">
            <div class="row" [formGroup]="accountConfirmGroup">
              <div class="col-md-3 col-lg-3 label-column-text">
                <h5 class="pb-3 font-weight-bold">
                  {{ Localization.Password | translate}}
                </h5>
              </div>
              <div class="col-md-1 col-lg-1">
              </div>
              <div class="col-md-7 col-lg-7">
                <div class="md-form mt-3 mb-3">
                  <input mdbInput type="password" id="password" maxlength="100" class="form-control validate" formControlName="password">
                  <label for="password" class="ml-0" data-error="wrong" data-success="right">{{ Localization.Password | translate }}</label>
                </div>
              </div>
            </div>
            <div class="row" [formGroup]="accountConfirmGroup">
              <div class="col-md-3 col-lg-3 label-column-text">
                <h5 class="pb-3 font-weight-bold">
                  {{ Localization.ConfirmPassword | translate}}
                </h5>
              </div>
              <div class="col-md-1 col-lg-1">
              </div>
              <div class="col-md-7 col-lg-7">
                <div class="md-form mt-3 mb-3">
                  <input mdbInput type="password" id="passwordConfirm" maxlength="100" class="form-control validate" formControlName="passwordConfirm">
                  <label for="passwordConfirm" class="ml-0" data-error="wrong" data-success="right">{{ Localization.ConfirmPassword | translate }}</label>
                </div>
              </div>
            </div>
            <div *ngIf="accountConfirmGroup.hasError('passwordToShort')" class="row justify-content-center mt-2 text-danger animated fadeInDown">
              <h5>{{ Localization.PasswordMustBeAtLeast | translate: {value: 6} }}</h5>
            </div>
            <div *ngIf="accountConfirmGroup.hasError('mismatch')" class="row justify-content-center mt-2 text-danger">
              <h5>{{ Localization.ConfirmPasswordDoesNotMatchThePassword | translate}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-2">
              <div class="license" [innerHTML]="licenseContent">
              </div>
            </div>
          </div>
          <div class="row justify-content-center mt-3">
            <div class="form-check">
              <mdb-checkbox [inline]="true" (change)="onAgreeToTermsChange($event.checked)">{{ Localization.IHaveReadAndAgreeToTheLicenseAgreementAbove | translate}}</mdb-checkbox>
            </div>
          </div>
          <div class="row justify-content-center mt-3">
            <button mdbBtn type="button" color="amber" mdbWavesEffect [disabled]="!this.accountConfirmGroup.valid || !agreedToTerms" (click)="onSubmit()">
              {{ Localization.GetStarted | translate}}
            </button>
          </div>
        </mdb-card-body>
      </mdb-card>
    </div>
  </div>
  <div class="middle-screen-loader" *ngIf="showSpinner || !translationCompleted">
    <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
  </div>
</div>
